import { Controller, UseFormReturn } from "react-hook-form";
import { FormGroup, FormControlLabel, Switch, FormHelperText } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../../../contexts/app_context/app_context";

/**
 * FormSwitchInput
 */

type Props<T extends {}> = {
  name: keyof T;
  activeLabel?: string;
  inactiveLabel?: string;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  readOnly?: boolean,
  reactHookForm: UseFormReturn<T>;
  onChange?: (newValue: boolean) => void;
};

export const FormSwitchInput = <T extends {},>({
  name,
  activeLabel = 'Ativo',
  inactiveLabel = 'Inativo',
  labelPlacement,
  readOnly,
  reactHookForm,
}: Props<T>) => {
  const { theme } = useContext(AppContext)
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        let helperText: string | null = null;
        let value = false;

        if (name in formState.errors) {
          const error = formState.errors[name] as any;
          if (typeof error.message === 'string') {
            helperText = error.message;
          }
        }

        if (typeof field.value === 'boolean') {
          value = field.value;
        } else if (typeof field.value === 'number') {
          value = field.value !== 0;
        } else {
          value = field.value ? true : false;
        }

        return (
          <FormGroup>
            <FormControlLabel
              sx={{ color: theme === "dark" ? "white" : "black" }}
              label={value === true ? activeLabel : inactiveLabel}
              labelPlacement={labelPlacement}
              control={
                <Switch
                  readOnly={readOnly}
                  checked={value}
                  onChange={(e) => { if (!readOnly) field.onChange(e.target.checked); }}
                  sx={{
                    color: "#009C4E",
                    '& .MuiSwitch-switchBase': {
                      '&.Mui-checked': {
                        color: '#009C4E',
                        '& + .MuiSwitch-track': {
                          backgroundColor: '#009C4E',
                        },
                      },
                    }
                  }}
                />
              } />

            <FormHelperText id={`${name as string}-component-error-text`} error={true}>
              {helperText}
            </FormHelperText>
          </FormGroup>
        );
      }} />
  );
}